import React, { useState, useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { Link } from 'gatsby';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: var(--nav-height);
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero: React.FC = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, my name is</h1>;
  const two = <h2 className="big-heading">Rashed Iqbal.</h2>;
  const three = <h3 className="big-heading">I build AI agents & web solutions.</h3>;
  const four = (
    <>
      <p>
        I’m a software engineer specializing in crafting exceptional digital products. Lately I’ve
        been diving deep into AI — building AI agents, LLM-powered tools, and agentic workflows.
        Currently leading projects and mentoring developers as a senior developer while actively
        shipping open-source tools and AI-powered software.
      </p>
    </>
  );
  const five = (
    <Link className="email-link" to="/#projects">
      Explore My Work!
    </Link>
  );

  const items = [one, two, three, four, five];
  const itemRefs = useRef<React.RefObject<HTMLDivElement | null>[]>(items.map(() => React.createRef()));

  return (
    <StyledHeroSection>
      <TransitionGroup component={null}>
        {isMounted &&
          items.map((item, i) => (
            <CSSTransition
              key={i}
              classNames="fadeup"
              timeout={loaderDelay}
              nodeRef={itemRefs.current[i]}>
              <div ref={itemRefs.current[i]} style={{ transitionDelay: `${i + 1}00ms` }}>
                {item}
              </div>
            </CSSTransition>
          ))}
      </TransitionGroup>
    </StyledHeroSection>
  );
};

export default Hero;
